import { Autocomplete, Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import React, { createRef, useMemo } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { ProductCategoryDto } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { getProductCategories } from '../../product/redux/productSelectors';
type OwnProps = {
    handleAmountChange: (val: number) => void;
    useBasePrice: boolean;
    handleUseBasePrice: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleProductCategorySelected: (dto: ProductCategoryDto | null) => void;
    amount: number;
    name: string;
    productCategoryId: number | undefined;
};

const mapStateToProps = (state: RootState) => ({
    isEditCostDialogLoading: state.calculation.isEditCostDialogLoading,
    productCategories: getProductCategories(state)
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductCategoryCostDialogContent = ({
    isEditCostDialogLoading,
    handleProductCategorySelected,
    handleAmountChange,
    handleUseBasePrice,
    useBasePrice,
    amount,
    productCategoryId,
    productCategories
}: Props) => {
    const amountInputRef = createRef();
    const productCategoryValues = useMemo(() => Object.values(productCategories), [productCategories]);

    return (
        <div>
            <Grid container direction="column">
                <Autocomplete
                    onChange={(_, value) => handleProductCategorySelected(value)}
                    value={productCategoryId ? productCategories[productCategoryId] : null}
                    options={productCategoryValues}
                    getOptionLabel={productCategory => `${productCategory.name}`}
                    getOptionKey={option => option.productCategoryId}
                    renderInput={params => <TextField {...params} label="" variant="outlined" fullWidth />}
                    disabled={isEditCostDialogLoading}
                />
                <NumberFormat
                    getInputRef={amountInputRef}
                    customInput={TextField}
                    value={amount}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    suffix=" %"
                    disabled={isEditCostDialogLoading}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    style={{ padding: '6px 0 7px', marginTop: '12px' }}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={useBasePrice}
                            onChange={handleUseBasePrice}
                            name="useBasePrice"
                            color="primary"
                            disabled={isEditCostDialogLoading}
                        />
                    }
                    label="Calculate using base price"
                />
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(ProductCategoryCostDialogContent);
